import { Component } from '@angular/core';
import {LayoutWrapperComponent} from '../layout-wrapper/layout-wrapper.component';
import {RouterOutlet} from '@angular/router';


@Component({
  selector: 'app-base-layout',
  standalone: true,
  imports: [
    LayoutWrapperComponent,
    RouterOutlet
],
  templateUrl: './base-layout.component.html',
  styleUrl: './base-layout.component.scss'
})
export class BaseLayoutComponent {

}
